<form class="nonEnumeratedproviderForm">
  <div class="row main-home py-0">
    <div class="col-md-12">
      <p role="heading" aria-level="1">Please enter any information you have regarding the {{title}}</p>
    </div>
  </div>
  @if (isNameRequired) {
    <div class="row main-home">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        @if (isNameRequired) {
          <span class="col-form-label" style="font-size:14px;" >
            Organization Name or First & Last Name Required
          </span>
        }
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
      </div>
    </div>
  }
  <div class="row main-home" role="form">
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center" [formGroup]="nonEnumeratedProviderFormPart1">
      @if (isformloaded) {
        <app-json-form [controlsData]="nonEnumeratedProviderFormData1.controls" [formData]="nonEnumeratedProviderFormPart1"
        (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
      }
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center" [formGroup]="nonEnumeratedProviderFormPart2">
      @if (isformloaded) {
        <app-json-form [controlsData]="nonEnumeratedProviderFormData2.controls" [formData]="nonEnumeratedProviderFormPart2"
        (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
      }
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center" [formGroup]="nonEnumeratedProviderFormPart3">
      @if (isformloaded) {
        <app-json-form [controlsData]="nonEnumeratedProviderFormData3.controls" [formData]="nonEnumeratedProviderFormPart3"
        (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
      }
    </div>
  </div>

</form>